import useTrls from 'hooks/translation/useTrls';

import TableHeadCell from 'components/Table/TableHeadCell';
import TableRow from 'components/Table/TableRow';

const Header = () => {
    const trl = useTrls();

    return (
        <TableRow>
            <TableHeadCell>{trl('admin.Invoices.InvoicesDetail.Invoice.Charges.createdAt')}</TableHeadCell>
            <TableHeadCell>{trl('admin.Invoices.InvoicesDetail.Invoice.Charges.amount')}</TableHeadCell>
            <TableHeadCell>{trl('admin.Invoices.InvoicesDetail.Invoice.Charges.number')}</TableHeadCell>
        </TableRow>
    );
};

export default Header;
